export interface LastPaidPrice {
  amount: number;
  memberCount: number;
}

export interface RenewalPriceChange {
  memberCount: number;
  previousAmount: number;
}

export const getRenewalPriceChange = ({
  lastPaidPrices,
  newAmount,
}: {
  lastPaidPrices: LastPaidPrice[];
  newAmount: number;
}): RenewalPriceChange | null => {
  const changedPrices = lastPaidPrices.filter((lastPaidPrice) => lastPaidPrice.amount !== newAmount);
  if (changedPrices.length === 0) {
    return null;
  }

  return {
    memberCount: changedPrices.reduce((total, changedPrice) => total + changedPrice.memberCount, 0),
    previousAmount: Math.min(...changedPrices.map((changedPrice) => changedPrice.amount)),
  };
};
